


















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Surface, Typography, Picture } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';

import eventBus from '@/utils/eventBus';
import flagKeys from '@/constants/flagKeys';

@Component({ components: { Surface, Typography, Picture, FilledButton } })
export default class CoinsInstructionsModal extends Vue {
  @Prop({ default: 1 }) readonly coinValue?: number;

  onClose() {
    eventBus.$emit('closeModal');
  }

  get businessCurrencyName() {
    return (
      this.$store.getters['internationalization/getCountrySettings']
        .currencyShorthand || 'USD'
    );
  }

  get businessCurrency() {
    return (
      this.$store.getters['internationalization/getCountrySettings']
        .currencySymbol || '$'
    );
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }
}
